import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="route-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-primary/20 border-t-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (roles) {
    // Dual-role support : un user avec linked_roles peut accéder aux
    // dashboards de ses rôles secondaires (ex. passager devenu conducteur).
    const allowed = new Set([user.role, ...(user.linked_roles || [])]);
    if (!roles.some((r) => allowed.has(r))) return <Navigate to="/" replace />;
  }
  return children;
}
